import {
  drawerWidth,
  transition,
  container,
  borderSubtleColor,
  pageBgColor,
} from 'assets/jss/material-dashboard-react';

const appStyle = theme => ({
  wrapper: {
    position: 'relative',
    top: '0',
    height: '100vh',
    backgroundColor: pageBgColor,
  },
  loginPanel: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 'calc(100vh - 80px)',
    padding: '32px 16px',
    boxSizing: 'border-box',
  },
  mainPanel: {
    [theme.breakpoints.up('md')]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
    overflow: 'auto',
    position: 'relative',
    float: 'right',
    ...transition,
    maxHeight: '100%',
    width: '100%',
    overflowScrolling: 'touch',
  },
  content: {
    marginTop: '0',
    padding: '28px 24px 40px',
    minHeight: 'calc(100vh - 123px)',
  },
  pageHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
    paddingBottom: 14,
    borderBottom: `1px solid ${borderSubtleColor}`,
  },
  pageHeaderTitle: {
    margin: 0,
    fontSize: 22,
    fontWeight: 500,
    color: '#1F2A32',
  },
  container,
  map: {
    marginTop: '70px',
  },
});

export default appStyle;
